export default function Heading1({ title = 'Haeding', className = '', accentClass = 'from-pink-600 to-purple-600' }) {
  return (
    <div className={className}>
      <h2 className="text-3xl md:text-4xl font-bold text-gray-900">{title}</h2>
      <div className={`h-1 w-20 bg-gradient-to-r ${accentClass} mt-3 rounded-full`} />
    </div>
  );
}
